




import { Vue, Component } from 'vue-property-decorator';
import { orderListTypes, focusTabName } from '@/const/order';
import ContentBottom from '@/components/shipping/order/ContentBottom.vue';

@Component({
  components: {
    ContentBottom,
  },
})
export default class OrderDepositWait extends Vue {
  private orderListTypes = orderListTypes.DEPOSIT_WAIT;
  private orderSearchTypes = focusTabName.ORDER_TAB;
}
